import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { TabMenu } from 'primereact/tabmenu'

import { Header } from '../../../../../components/Header'

export const Title: React.FC = () => {
  const { t } = useTranslation('buyerSettings')

  const [activeIndex, setActiveIndex] = useState(0)

  const scrollToElement = (elementId: string) => {
    const element = document.getElementById(elementId)

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const items = [
    {
      label: t('tabMenu.general.label'),
      command: () => {
        setActiveIndex(0)
        setTimeout(() => scrollToElement('settings-general'), 100)
      },
    },
    {
      label: t('tabMenu.additionalProperties.label'),
      command: () => {
        setActiveIndex(1)
        setTimeout(() => scrollToElement('settings-additional-properties'), 100)
      },
    },
    {
      label: t('tabMenu.eInvoice.label'),
      command: () => {
        setActiveIndex(2)
        setTimeout(() => scrollToElement('settings-e-invoice'), 100)
      },
    },
  ]

  return (
    <div className="bg-white mb-6 -mx-6 px-6">
      <Header title={t('title.title')} />
      <TabMenu
        model={items}
        activeIndex={activeIndex}
        onTabChange={e => setActiveIndex(e.index)}
        className="overflow-visible"
      />
    </div>
  )
}
